import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Header from '../components/Header/Header';
import SEO from '../components/SEO/SEO';
import { 
  trackMenuClick, 
  trackReservationButtonClick, 
  trackDirectionsClick, 
  trackPhoneClick 
} from '../utils/analytics';
import { HOME_ROUTE_KEY } from '../utils/sessionStorageKeys';
import './HomePage.css';

const HomePage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    if (!sessionStorage.getItem(HOME_ROUTE_KEY)) {
      sessionStorage.setItem(HOME_ROUTE_KEY, '/');
    }
  }, []);

  const handleMenuClick = () => {
    trackMenuClick();
    navigate('/menu');
  };

  const handleDirectionsClick = () => {
    trackDirectionsClick();
    window.open('https://maps.app.goo.gl/GSM4UuLjRERhQo7CA', '_blank');
  };

  const handleReservationClick = () => {
    trackReservationButtonClick();
    navigate('/reservation');
  };

  const handlePhoneClick = () => {
    trackPhoneClick();
    window.location.href = 'tel:+21626773104';
  };

  return (
    <div className="home-page">
      <SEO 
        title="Accueil" 
        description="Aqua Farina | Le meilleur de la cuisine italienne aux Jardins de Carthage. Pizzas artisanales, ambiance chaleureuse et service de qualité. Consultez notre menu et réservez dès maintenant."
        canonical="/"
      />
      <Header />
      <div className="home-content">
        <h1 className="restaurant-name">{t('aquaFarina')}</h1>
        <div className="icons-container">
          <button className="icon-button menu-button" onClick={handleMenuClick}>
            <div className="icon-wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="80"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 12h18M3 6h18M3 18h18" />
              </svg>
            </div>
            <span className="icon-label">{t('menu')}</span>
          </button>

          <button
            className="icon-button reservation-button"
            onClick={handleReservationClick}
          >
            <div className="icon-wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="80"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                <polyline points="17 21 17 13 7 13 7 21" />
                <polyline points="7 3 7 8 15 8" />
              </svg>
            </div>
            <span className="icon-label">{t('reservation')}</span>
          </button>

          <button
            className="icon-button directions-button"
            onClick={handleDirectionsClick}
          >
            <div className="icon-wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="80"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <span className="icon-label">{t('getDirections')}</span>
          </button>
        </div>

        {/* Section Contact */}
        <div className="contact-section">
          <h2 className="contact-title">{t('contactUs')}</h2>
          <a 
            href="tel:+21626773104" 
            className="phone-link"
            onClick={handlePhoneClick}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            <span>+216 26 773 104</span>
          </a>
        </div>

        {/* Section Maps */}
        <div className="maps-section">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1547.1126576995985!2d10.297577058565748!3d36.849088792956124!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd4b81e16381c7%3A0x47bfdadaebf83b05!2sAqua%20Farina!5e0!3m2!1sen!2stn!4v1768784054671!5m2!1sen!2stn"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Aqua Farina Location"
            className="google-map"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
